<script>
    import {pie as Pie, arc} from "d3-shape";

    export let width;
    export let height;
    export let segments;
    export let showLabels = true;
    export let valueFmt = e => e.toLocaleString();

    const pie = Pie().sort(null).value(d => d.value);

    $: arcFn = arc().innerRadius(0).outerRadius(Math.min(width, height) / 2 - 1);

    $: arcs = pie(segments);

    $: viewBox = [-width / 2, -height / 2, width, height].map(d => d * 1.2).join(',');


    $: radius = Math.min(width, height) / 2 * 0.8;
    $: arcLabel = arc().innerRadius(radius).outerRadius(radius);
</script>

<svelte:options namespace="svg"/>

<svg viewBox={viewBox} class="pie-chart">
    <g stroke="white">
        {#each arcs as arc}
            <path fill={arc.data.color} d={arcFn(arc)}>
                <title>{arc.data.name}: {valueFmt(arc.data.value)}</title>
            </path>
        {/each}
    </g>
    {#if showLabels}
        <g font-family="sans-serif" font-size="8" text-anchor="middle">
            {#each arcs as arc}
                <text transform={`translate(${arcs.length > 1 ? arcLabel.centroid(arc) : '0,0'})`}>
                    <tspan y="-0.4em" font-weight="bold">
                        { arc.data.name }
                    </tspan>
                    {#if arc.endAngle - arc.startAngle > 0.25}
                        <tspan x="0" y="0.7em" fill-opacity="0.7">
                            { valueFmt(arc.data.value) }
                        </tspan>
                    {/if}
                </text>
            {/each}
        </g>
    {/if}
</svg>
